import styled from 'styled-components';

export const SummaryLine = styled.p`
  color: var(--color-text);
  font-size: 14px;
  line-height: 1.55;
  margin: 8px 0 0;
  white-space: pre-wrap;
`;
